import React, { useMemo } from 'react';
import { NativeSelect } from '@mui/material';

const TAX_CODE_DROPDOWN_THRESHOLD = 3;


export default function TaxCodeSelector({
  taxCodes = [],
  value,
  disabled = false,
  onChange,
  className = '',
}) {
  const codes = useMemo(
    () => [...new Set((taxCodes || []).filter(Boolean))],
    [taxCodes],
  );
  const currentValue = value || codes[0] || '';

  if (codes.length <= TAX_CODE_DROPDOWN_THRESHOLD) {
    const handleCycle = () => {
      if (disabled || codes.length === 0) return;
      const currentIndex = codes.findIndex((code) => code === currentValue);
      const nextIndex = currentIndex === -1 || currentIndex + 1 >= codes.length ? 0 : currentIndex + 1;
      onChange?.(codes[nextIndex]);
    };

    return (
      <button
        type="button"
        className={`btn btn-sm btn-secondary ${className}`.trim()}
        disabled={disabled || codes.length === 0}
        onClick={handleCycle}
      >
        {currentValue}
      </button>
    );
  }

  return (
    <NativeSelect
      className={className}
      value={currentValue}
      disabled={disabled || codes.length === 0}
      onChange={(event) => onChange?.(event.target.value)}
      inputProps={{ 'aria-label': 'Tax code' }}
      disableUnderline
    >
      {codes.map((code) => (
        <option key={code} value={code}>
          {code}
        </option>
      ))}
    </NativeSelect>
  );
}
